import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import { DashboardLayout } from "dashboard/ui";
import { authRoutes, dashboardRoutes } from "./app/utils";
import AuthGuard from "providers/auth-guard";
import { useUserFlow } from "flows";

function DashboardApp() {
  const userFlow = useUserFlow();
  return (
      <BrowserRouter>
        <Routes>
          {authRoutes.map((route, index) => {
            return (
              <Route
                path={route.path}
                key={route.path + "---" + index}
                element={<route.Component />}
              />
            );
          })}
          <Route element={<AuthGuard {...{
            loginRoute: "login"
          }}>
            <DashboardLayout {...{
              onSave: userFlow.onUpdateUser,
              onLogout() {
                // authHook.logout(routeNames.login);
              },
            }}/>
          </AuthGuard>}>
            {dashboardRoutes.map((route, index) => {
              return (
                <Route
                  path={route.path}
                  key={route.path + "---" + index}
                  element={ <Suspense>
                          <route.Component />
                        </Suspense>
                  }
                />
              );
            })}
          </Route>
          <Route path="*" element={<h1>404</h1>} />
          </Routes> 
      </BrowserRouter>
  );
}

export default DashboardApp;
